import { UserRelation } from './auth';
import { Nullable } from './global';

export interface Preset {
  id: string;
  refId: string;
  type: string;
  name: string;
  value: string;
  user: UserRelation;
  created: string;
  modified: string;
  isMine?: boolean;
  enforceUniqueName?: boolean;
  visibility?: Nullable<PresetVisibility>;
  favorite?: boolean;
  metadata?: string;
  workspace: {
    id: string;
    user: UserRelation;
  };
}

export interface ParsedPreset<T = string> extends Omit<Preset, 'value'> {
  value: T;
}

export type CreatePresetRequest<T = string> = Pick<
  Preset,
  'name' | 'type' | 'favorite' | 'metadata' | 'visibility'
> & {
  value: T;
  allowDuplication?: boolean;
  refId?: string;
};

export type UpdatePresetRequest<T = string> = Pick<Preset, 'metadata'> & {
  value: T;
};

export enum PresetVisibility {
  ALL = '',
  PRIVATE = 'PRIVATE',
  INTERNAL = 'INTERNAL',
  PUBLIC = 'PUBLIC',
}
